import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, message } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import viVN from 'antd/lib/locale/vi_VN';
import './index.css';
import App from '@/App';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/utils/translations/i18n';
import { CookiesProvider } from 'react-cookie';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import utils from '@/utils';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
      gcTime: 10000,
      retry(failureCount) {
        const max = 4;
        // if (!appGlobal.isWebview) {
        //   message.error(error.message + `(Tải lại lần ${failureCount + 1}/${max + 1})`);
        // }
        return failureCount < max;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
      onMutate() {
        utils.loading(true);
      },
      onError(error: any) {
        utils.loading(false);
        console.log(error);
        message.error(error?.response?.data?.error?.message || error.cause?.message || error?.message);
      },
      onSuccess() {
        utils.loading(false);
        message.success('Thành công');
      },
    },
  },
});

// const customInput: any = {
//   colorBgContainer: '#FAFAFA',
//   colorBorder: '#F0F0F0',
// colorPrimary: '#57D9D9',
//   colorPrimaryHover: 'red',
//   colorTextDisabled: 'rgba(28, 31, 79, 0.7)',
//   colorBgContainerDisabled: '#FAFAFA',
// };

root.render(
  //   <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <I18nextProvider i18n={i18n}>
      <ConfigProvider
        input={{ autoComplete: 'off' }}
        locale={{
          ...viVN,
          Form: { defaultValidateMessages: { required: 'Vui lòng điền thông tin!' } },
        }}
        modal={{ className: 'base-modal' }}
        theme={{
          components: {
            Checkbox: { colorBgContainerDisabled: '#57D9D9' },
            Segmented: {
              /* here is your component tokens */
              itemSelectedBg: '#37D2D2',
              itemSelectedColor: 'rgba(255, 255, 255, 1)',
              itemHoverBg: '#37D2D2',
              itemHoverColor: 'rgba(255, 255, 255, 1)',
              itemColor: 'rgba(28, 31, 79, 1)',
              trackBg: 'rgba(245, 245, 245, 1)',
              trackPadding: 2,
            },
          },
          token: {
            colorText: '#1C1F4F',
            colorError: '#F5781B',
            colorPrimary: '#57D9D9',
            colorTextDisabled: 'rgba(28, 31, 79, 0.7)',
            colorBgContainerDisabled: '#FAFAFA',
            colorBgContainer: '#FAFAFA',
            colorBorder: '#F0F0F0',
          },
        }}
      >
        <BrowserRouter>
          <CookiesProvider>
            <App />
          </CookiesProvider>
        </BrowserRouter>
      </ConfigProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </I18nextProvider>
  </QueryClientProvider>,
  //   </React.StrictMode>,
);
